import { Stack, StackProps, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';

export const SubHeader = ({
  children,
  sx,
  ...props
}: PropsWithChildren & Omit<StackProps, 'children'>) => {
  const theme = useTheme();

  return (
    <Stack
      id="sub-header"
      sx={{
        background: theme.colors.gradients.metal,
        borderBottom: `1px solid ${theme.colors.functional.subject.border}`,
        height: '68px',
        width: '100%',
        px: { md: 5, sm: 3, xs: 3 },
        py: 3,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Stack>
  );
};
